<template>
  <button class="definition-node-drop-zone level-0"
    :draggable="false"
    @dragover="dragOverHandler"
    @dragleave="dragLeaveHandler"
    @drop="dropHandler"
    @dragend="dragEndHandler"
  >
    Drop at end
  </button>
</template>

<script>
  import DragAndDropHandlers from '@/appComponents/oldWorkbench/targetDefinition/mixins/DragAndDropHandlers'
  import { definitionPartTypes } from '@/appComponents/oldWorkbench/targetDefinition/store/mutations'

  export default {
    mixins: [
      DragAndDropHandlers
    ],
    props: {
      level: {
        type: Number,
        default: 0
      }
    },
    data () {
      return {
        defType: definitionPartTypes.DROP_ZONE,
        definitionId: 'drop-zone'
      }
    }
  }
</script>

<style lang="scss">
  .definition-node-drop-zone {
    position: relative;
    $border-radius: rem(15);

    flex-shrink: 0;
    flex-grow: 0;
    box-sizing: border-box;
    color: white;
    height: rem(30);
    padding: 0 rem(30);
    border-radius: rem(15);
    border: rem(2) solid color(grays, medium);
    margin-top: rem(5);
    margin-bottom: rem(5);
    margin-left: rem(5);
    opacity: 0.3;

    &.level-0 {
      background-color: color(grays, dark);
      border-color: color(grays, medium);

      &:hover {
        $bg-color: lighten(color(grays, medium), 5%);
        background-color: $bg-color;
        border-color: $bg-color;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// DefinitionNodeDropZone.vue?f04b4bf6